export default "__VITE_ASSET__CVzV5fhH__"